/* eslint-disable */
import request from './helpers'

export function listCollection (size, page) {
    return request ({
        url: '/api/v1/topic/collection/query',
        method: 'get',
        params: {
            size, page
        }
    })
}

export function createCollection (data) {
    return request ({
        url: '/api/v1/topic/collection',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateCollection (id, data) {
    return request ({
        url: '/api/v1/topic/collection/' + id,
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function activeCollection (id, active) {
    return request ({
        url: '/api/v1/topic/collection/' + id + '/status',
        method: 'put',
        data: {
            active
        },
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function removeCollection (id, data) {
    return request ({
        url: '/api/v1/topic/collection/' + id,
        method: 'delete'
    })
}

export function getTopicByNames (data) {
    return request ({
        url: '/api/v1/topic/names',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
